import { render, staticRenderFns } from "./team_club_detailData.vue?vue&type=template&id=2a2c480a&"
import script from "./team_club_detailData.vue?vue&type=script&lang=js&"
export * from "./team_club_detailData.vue?vue&type=script&lang=js&"
import style0 from "./team_club_detailData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports